var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.285 12.951v5.523c0 .764-.618 1.383-1.383 1.383h-5.52l6.903-6.906zM13.854 7c.28 0 .551.033.811.097L2.504 19.264A3.43 3.43 0 0 1 1 16.424V8.383C1 7.619 1.619 7 2.383 7h11.47zM25 8.546v9.765a.857.857 0 0 1-1.311.727l-4.286-2.679a.858.858 0 0 1-.403-.727l-.001-4.396 1.296-1.296 3.394-2.12A.857.857 0 0 1 25 8.546z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.293.293a1 1 0 0 1 1.497 1.32l-.083.094-24 24a1 1 0 0 1-1.497-1.32l.083-.094 24-24z",
    fill: "#DE3C3D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartVideo);
export default __webpack_public_path__ + "static/media/start-video.7453a6e0030a79a26aa7eac2b008f6fd.svg";
export { ForwardRef as ReactComponent };